import { Text } from "@medoma/components/Text/Text";
import styles from "./ShiftTemplates.module.scss";
import { TimeSpan } from "@/components/Time/TimeSpan";
import { useSelectedDate } from "@/Utils/useSelectedDate";
import { setTimeOnDate } from "@/Utils/DateUtils";

const TemplateShiftTime = ({
  startTime,
  endTime,
}: {
  startTime: string;
  endTime: string;
}) => {
  const selectedDate = useSelectedDate();
  const endsNextDay = startTime > endTime;

  const startDateTime = setTimeOnDate({
    selectedDate,
    time: startTime,
    addedDays: 0,
  });

  const endDateTime = setTimeOnDate({
    selectedDate,
    time: endTime,
    addedDays: endsNextDay ? 1 : 0,
  });

  const dateFormatter = new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
  });
  const formattedDateSpan = endsNextDay
    ? dateFormatter.formatRange(startDateTime, endDateTime)
    : dateFormatter.format(startDateTime);

  return (
    <div className={styles.shiftDateTime}>
      <TimeSpan timespan={{ start: startDateTime, end: endDateTime }} />
      <Text element="div" color="faded" size="smallest">
        {formattedDateSpan}
      </Text>
    </div>
  );
};

export { TemplateShiftTime };
